export const GET_ALL_NOTIFICATION_SUCCESS = "GET_ALL_NOTIFICATION_SUCCESS"
export const GET_ALL_NOTIFICATION_LOADING = "GET_ALL_NOTIFICATION_LOADING"
export const ADD_NEW_NOTIFICATION= "ADD_NEW_NOTIFICATION"
export const  DELETE_NOTIFICATION = "DELETE_NOTIFICATION"
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION"